var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB5800",
    d: "M13,2.05c5.05,0.5,9,4.77,9,9.95c0,1.45-0.32,2.83-0.88,4.07l-2.62-1.53C18.82,13.75,19,12.9,19,12 c0-3.53-2.609-6.43-6-6.92V2.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M12,19c2.21,0,4.17-1,5.45-2.62l2.6,1.53C18.23,20.391,15.3,22,12,22C6.47,22,2,17.5,2,12 c0-5.19,3.94-9.45,9-9.95v3.03C7.61,5.57,5,8.47,5,12C5,15.866,8.134,19,12,19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#008F68",
    d: "M12,6c3.313,0,6,2.687,6,6c0,2.971-2.16,5.439-5,5.92v-3.09c1.17-0.41,2-1.52,2-2.83c0-1.657-1.344-3-3-3 l-0.55,0.05L9.91,6.38C10.56,6.13,11.26,6,12,6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D11250",
    d: "M6,12c0-1.86,0.85-3.5,2.18-4.62l1.54,2.67C9.27,10.57,9,11.26,9,12c0,1.311,0.83,2.42,2,2.83v3.09 C8.16,17.439,6,14.971,6,12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsActive);
export default __webpack_public_path__ + "static/media/insights_active.6aa797a6.svg";
export { ForwardRef as ReactComponent };